export default __webpack_public_path__ + "static/0319-fe61553f73131008b5b8158e811758ad.png";